
import Vue from "vue"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'

export default Vue.extend({
  props:{
	 icon:{
		default:faBars,
		required:true
	 }
  },
  components:{
	FontAwesomeIcon
  }
})
